// extracted by mini-css-extract-plugin
module.exports = {"Container":"Accordion_Container__DnyvY","Header":"Accordion_Header__W5zgU","Content":"Accordion_Content__nIez_","Hide":"Accordion_Hide__hRGSd","Show":"Accordion_Show__KKruf"};